export const AuthorBox = () => (
  <div className="max-w-3xl mx-auto mt-16 pt-8 border-t border-[#27272A]">
    <div className="flex items-start gap-6">
      <img
        src="https://customer-assets.emergentagent.com/job_site-clone-platform/artifacts/eyoeieqm_Terry_aboutme_photo_02.jpg"
        alt="Terry Webster"
        className="w-20 h-20 object-cover rounded-full"
      />
      <div>
        <h3 className="text-xl font-bold mb-2">Terry Webster</h3>
        <p className="text-[#A1A1AA] leading-relaxed">
          Australian filmmaker and cinematographer with 17 years of experience. Passionate about visual
          storytelling and the intersection of technology and creativity.
        </p>
      </div>
    </div>
  </div>
);
